import { render, staticRenderFns } from "./CrudCreate.vue?vue&type=template&id=525e9370&scoped=true&"
import script from "./CrudCreate.vue?vue&type=script&lang=js&"
export * from "./CrudCreate.vue?vue&type=script&lang=js&"
import style0 from "./CrudCreate.vue?vue&type=style&index=0&id=525e9370&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525e9370",
  null
  
)

export default component.exports